export enum managementsTabsEnum {
  General = 'general',
  LlmSettings = 'llm-settings',
  ChatLlm = 'chat-llm',
  ChatVoice = 'chat-voice',
  Users = 'users',
  ApiKeys = 'api-keys',
  Sso = 'sso',
  Logs = 'logs',
  Packages = 'packages',
  Connectors = 'connectors',
  System = 'system',
  Prompts = 'prompts',
  AiBuilder = 'ai-builder',
  DataLake = 'data-lake',
}